import axios from "axios";
import { GrDocumentPdf, GrDocumentText } from "react-icons/gr";
import { downloadFile } from "../../../shared/services/LenderRequestService";

export const DocumentItem = ({docItem}) => {
  // console.groupCollapsed('DocumentItem')
  // console.log('item', item)
  // console.log('documents', item.documents)
  // console.log('docItem', docItem)
  // console.groupEnd()

  
  return (
    <div className="stack-item request-doc-item">
      <div className="stack-cell file-cell">
        <div className="stack-cell-header">File</div>
        <div className="stack-cell-value">
          <span className="doc-icon-cell">{
            (docItem.s3ObjectName?.toLowerCase().endsWith(".pdf"))
              ? (<GrDocumentPdf className="doc-filetype-icon" />)
              : docItem.s3ObjectName?.toLowerCase().endsWith(".docx")
              ? (<GrDocumentText className="doc-filetype-icon" />)
              : (<></>)
          }</span>
          <span
            className="pdf-link"
            onClick={() => downloadFile(docItem.docMapId, docItem.s3ObjectName)}
            style={{ cursor: "pointer", color: "#007bff", textDecoration: "underline" }}
          >
            {docItem.s3ObjectName}
          </span>
        </div>
      </div>
      <div className="stack-cell">
        <div className="stack-cell-header">Category</div>
        <div className="stack-cell-value">{docItem.category}</div>
      </div>
      <div className="stack-cell">
        <div className="stack-cell-header">Type</div>
        <div className="stack-cell-value">{docItem.documentName}</div>
      </div>
      <div className="stack-cell note-cell">
        <div className="stack-cell-header">Note</div>
        <div className="stack-cell-value comment-body">{docItem.notes || ""}</div>
      </div>
    </div>
  );
};